import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import { set } from "@/redux/modules/value/productDetail/productDetail.module";
import { getProductDetail } from "@/redux/modules/value/productDetail/productDetail.selectors";
import { TProductDetailState } from "@/redux/modules/value/productDetail/productDetail.types";

export const useProductDetail = () => {
    const productDetail = useSelector(getProductDetail);
    const dispatch = useThunkDispatch();

    const updateProductDetail = (data: Partial<TProductDetailState>) =>
        Promise.resolve(dispatch(set(data)));

    return {
        deliveryType: productDetail.deliveryType,
        quantity: productDetail.quantity,
        serviceProductSkus: productDetail.serviceProductSkus,
        updateProductDetail: updateProductDetail
    };
};
